module.exports = __webpack_public_path__ + "static/media/facebook.2696e45d.svg";